import { store } from "@store";
import { openDialog } from "@store/dialogs";
import type { IMediaFile } from "@/shared/types";
import type { CropData } from "../types";
import { CropperDialog } from "../components/cropper-dialog";

interface IBaseProps {
  imageSrc: string;
  /** When provided, this URL is shown in the cropper so the user always sees the original image with crop boundaries. */
  originalImageSrc?: string;
  /** When provided, the cropper opens with this crop area so the user sees the original image (but cropped with the boundaries). */
  defaultCropData?: CropData;
  /** When the editor image shape is blob or parallelogram, the cropper uses square stencil. */
  editorShape?: string;
  /** Called when the user saves a crop, so the caller can persist crop data and re-open with the same boundaries. */
  onCropDataSave?: (data: CropData) => void;
  /** When provided, the dialog closes immediately and this callback receives
   *  the blob for background upload by the caller (which stays mounted). */
  onBackgroundUpload?: (blob: Blob, blobUrl: string) => void;
}

type IProps = IBaseProps &
  (
    | {
        onCrop: (dataUrl: string, canvas: HTMLCanvasElement) => void;
        onCropAndUpload?: never;
      }
    | {
        onCrop?: never;
        onCropAndUpload: (
          mediaFile: IMediaFile,
          canvas: HTMLCanvasElement,
        ) => void;
      }
  );

export const openImageCropper = ({
  imageSrc,
  originalImageSrc,
  defaultCropData,
  editorShape,
  onCrop,
  onCropAndUpload,
  onCropDataSave,
  onBackgroundUpload,
}: IProps) => {
  store.dispatch(
    openDialog({
      id: CropperDialog.dialogId,
      content: CropperDialog,
      props: {
        imageSrc,
        originalImageSrc,
        defaultCropData,
        editorShape,
        onCrop,
        onCropAndUpload,
        onCropDataSave,
        onBackgroundUpload,
      },
    }),
  );
};
